
















import ForgotPasswordImageLink from '@spa/components/pages/auth/signup/shared/forgot-password/ImageLink.vue'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import HostPageLinkMixin from '@/mixin/HostPageLink'

@Component({
  components: {
    ForgotPasswordLink: ForgotPasswordImageLink,
  },
  mixins: [
    HostPageLinkMixin,
  ],
})
export default class CartLoginDefaultNote extends Vue {
  @Prop({ required: true })
  hostName: string
}
